<template>
  <span ref="root" class="chart-info-control">
    <button
      type="button"
      class="chart-info-button"
      :aria-describedby="visible ? tooltipId : undefined"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-label="label"
      @mouseenter="show"
      @mouseleave="hideUnlessPinned"
      @focus="show"
      @blur="hideUnlessPinned"
      @click.stop="togglePinned"
      @keydown.esc.stop="close"
    >
      <i class="fa fa-info" aria-hidden="true"></i>
    </button>
    <span v-if="visible" :id="tooltipId" class="chart-info-tooltip" role="tooltip">
      {{ text }}
    </span>
  </span>
</template>

<script>
let chartInfoSequence = 0;

export default {
  name: 'ChartInfoButton',
  props: {
    text: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Comprendre ce graphique',
    },
  },
  data() {
    chartInfoSequence += 1;

    return {
      visible: false,
      pinned: false,
      tooltipId: `chart-info-tooltip-${chartInfoSequence}`,
    };
  },
  mounted() {
    document.addEventListener('click', this.onDocumentClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
  },
  methods: {
    show() {
      this.visible = true;
    },
    hideUnlessPinned() {
      if (!this.pinned) this.visible = false;
    },
    togglePinned() {
      this.pinned = !this.pinned;
      this.visible = this.pinned;
    },
    close() {
      this.pinned = false;
      this.visible = false;
    },
    onDocumentClick(event) {
      if (!this.$refs.root?.contains(event.target)) this.close();
    },
  },
};
</script>

<style scoped>
.chart-info-control {
  display: inline-flex;
  position: relative;
}

.chart-info-button {
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgba(var(--suite241-admin-primary-rgb, 13, 110, 253), 0.35);
  border-radius: 999px;
  color: var(--suite241-admin-primary, var(--bs-primary));
  display: inline-flex;
  font-size: 0.72rem;
  font-weight: 800;
  height: 22px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 22px;
}

.chart-info-button:hover,
.chart-info-button:focus-visible,
.chart-info-button[aria-expanded='true'] {
  background-color: var(--suite241-admin-primary, var(--bs-primary));
  border-color: var(--suite241-admin-primary, var(--bs-primary));
  color: #ffffff;
  outline: 0;
}

.chart-info-tooltip {
  background: #1f2937;
  border-radius: 0.4rem;
  bottom: calc(100% + 0.55rem);
  box-shadow: 0 0.55rem 1.4rem rgba(15, 23, 42, 0.22);
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 600;
  left: 50%;
  line-height: 1.45;
  max-width: min(300px, 78vw);
  padding: 0.55rem 0.7rem;
  position: absolute;
  transform: translateX(-50%);
  width: max-content;
  z-index: 1100;
}

.chart-info-tooltip::after {
  border-left: 0.35rem solid transparent;
  border-right: 0.35rem solid transparent;
  border-top: 0.4rem solid #1f2937;
  content: '';
  left: 50%;
  position: absolute;
  top: 100%;
  transform: translateX(-50%);
}
</style>
